/**
 * Member Login Menu Toggle with Focus Out, Escape, and Click Outside Detection
 *
 * @param {boolean} [enableDebug=false] - Enable debugging output
 */
export default (enableDebug = false) => {
	const debug = enableDebug;
	const log = (...args) => {
		if (debug) console.log(...args);
	};

	const loginButton = document.getElementById('js-member-login-button');
	const loginMenu = document.getElementById('js-member-login-menu');
	const closeButton = document.getElementById('js-member-login-close');

	if (!loginButton || !loginMenu || !closeButton) {
		log('Required elements not found, exiting script.');
		return;
	}

	// Toggle function
	const toggleMenu = () => {
		const isOpened = loginButton.classList.contains('--opened');

		if (isOpened) {
			closeMenu();
		} else {
			loginButton.classList.add('--opened');
			loginMenu.classList.add('--opened');
			log('Menu opened');

			// Add keyboard and click event listeners
			document.addEventListener('keydown', handleKeyPress);
			document.addEventListener('click', handleClickOutside);
		}
	};

	// Close function
	const closeMenu = () => {
		if (loginButton.classList.contains('--opened')) {
			loginButton.classList.remove('--opened');
			loginMenu.classList.remove('--opened');
			log('Menu closed');

			// Remove event listeners
			document.removeEventListener('keydown', handleKeyPress);
			document.removeEventListener('click', handleClickOutside);
		}
	};

	// Handle keyboard interactions for Tab and Escape
	const handleKeyPress = (event) => {
		log(`Key pressed: ${event.key}`);

		if (event.key === 'Tab') {
			requestAnimationFrame(() => {
				if (
					!loginMenu.contains(document.activeElement) &&
					document.activeElement !== loginButton
				) {
					log('Tabbing out of menu, closing it.');
					closeMenu();
				}
			});
		} else if (event.key === 'Escape' || event.key === 'Esc') {
			log('Escape key detected, closing menu.');
			closeMenu();
		}
	};

	// Handle clicks outside of the login button and menu
	const handleClickOutside = (event) => {
		// If the click target is not within the login button or the login menu, close the menu.
		if (
			!loginButton.contains(event.target) &&
			!loginMenu.contains(event.target)
		) {
			log('Click outside detected, closing menu.');
			closeMenu();
		}
	};

	// Event Listeners for the toggle and close buttons
	loginButton.addEventListener('click', toggleMenu);
	closeButton.addEventListener('click', closeMenu);
};
